// extracted by mini-css-extract-plugin
module.exports = {"AttachedManuals":"AttachedManuals_AttachedManuals__3qeHk","AttachedManualsWrap":"AttachedManuals_AttachedManualsWrap__YnHTc"};